// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__gOFSd"};